import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
        Yükleniyor...
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  return children;
}
